import { render, staticRenderFns } from "./offer-custom-company-type.vue?vue&type=template&id=2ea1e37b&scoped=true&lang=pug"
import script from "./offer-custom-company-type.vue?vue&type=script&lang=js"
export * from "./offer-custom-company-type.vue?vue&type=script&lang=js"
import style0 from "@ui-common/vue-masked-input/dist/vue-masked-input.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./offer-custom-company-type.vue?vue&type=style&index=1&id=2ea1e37b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1e37b",
  null
  
)

export default component.exports